import { IModelBase } from 'common-components'
import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimTransactionType extends IModelBase {
  Name: string
  Value: string
}

@Injectable()
export class ClaimTransactionTypeODataService extends ODataService<IClaimTransactionType> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimTransactionTypes'
  }
}
